/*
  此文件作用在于，在webpack prod模式下打包的时候，
  通过resolve/alias 处配置，替换掉原来的vconsole，避免发生打包到线上还有vconsole的尴尬情况
 */
class vconsole {
  constructor() {
    console.log('vconsole is replaced')
  }
}

module.exports = vconsole



// WEBPACK FOOTER //
// ./src/frontend-lib/lib/fakevconsole.js